import React, { Component } from "react";
import ConfigService from "../../services/configuracion/ConfigService";
import history from "./login/history";


export default class Error404 extends Component {
  constructor(props) {
    super(props);
  }

  volverHome = (e) => {
    //history.push('/resumenGeneralSocio');
    history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
    window.location.reload();
  }
  volverLogin = (e) => {
    history.push('/');
    window.location.reload();
  }

  render() {
    return (
      <div className="error-404">
        <div id="notfound">
          <div className="notfound">
            <div className="notfound-404">
              <h1>404</h1>
            </div>
            <h2>Página no Encontrada.</h2>
            <p>No pudimos encontrar la página que buscabas. Puede volver a la pantalla de <a onClick={this.volverHome}>Resumen de Cuentas</a></p>
            <div className="imagen">
              <img src="/Logo_CU_Verde.PNG" />
            </div>
            {/*<div className="notfound-social">
              <a href="https://www.facebook.com/CooperativaUniversitaria?fref=ts"><i className="fas fa-facebook"></i></a>
              <a href="https://twitter.com/CU_Py"><i className="fa fa-twitter"></i></a>
              <a href="https://www.youtube.com/user/coopuniversitaria"><i className="fa fa-youtube"></i></a>
              <a href="https://api.whatsapp.com/send?phone=595985251700"><i className="fa fa-whatsapp"></i></a>
            </div>*/}
          </div>
        </div>
      </div>
    );
  }
}